/**
 * Wholesale form — Option A.
 * Validate mandatory fields only. When valid, allow native Shopify contact submit
 * so platform hCaptcha can attach its token (same pattern as the working shop form).
 * Do not preventDefault on valid submit, and do not call Shopify.captcha.protect.
 */
(function () {
  function initWholesaleForm(root) {
    const form = root.querySelector('form.hdt-wf__form');
    if (!form || form.dataset.hdtWfReady === 'true') return;
    form.dataset.hdtWfReady = 'true';
    form.setAttribute('novalidate', 'novalidate');

    /* Prefer Liquid-provided data-required-message (merchant/translated). */
    const requiredMessage = root.dataset.requiredMessage || '';

    function clearFieldError(field) {
      if (!field) return;
      field.classList.remove('hdt-wf__field--invalid');
      const input = field.querySelector('.hdt-wf__input, select, textarea');
      if (input) input.removeAttribute('aria-invalid');
      const errorEl = field.querySelector('[data-hdt-wf-error]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function markInvalid(input, message) {
      const field = input.closest('.hdt-wf__field');
      if (!field) return;
      field.classList.add('hdt-wf__field--invalid');
      input.setAttribute('aria-invalid', 'true');
      const errorEl = field.querySelector('[data-hdt-wf-error]');
      if (errorEl) {
        errorEl.textContent = message || requiredMessage;
        errorEl.hidden = false;
      }
    }

    function isRequiredInput(input) {
      if (!input || input.disabled || input.type === 'hidden') return false;
      return (
        input.hasAttribute('data-hdt-wf-required') ||
        input.hasAttribute('required') ||
        input.getAttribute('aria-required') === 'true'
      );
    }

    function fieldValue(input) {
      if (!input) return '';
      if (input.tagName === 'SELECT') {
        const selected = input.options[input.selectedIndex];
        if (!selected || selected.disabled || selected.value === '') return '';
        return String(selected.value).trim();
      }
      return String(input.value || '').trim();
    }

    function isFieldInvalid(input) {
      if (!isRequiredInput(input)) return { invalid: false };
      const value = fieldValue(input);
      if (value === '') return { invalid: true, message: requiredMessage };
      if (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return { invalid: true, message: requiredMessage };
      }
      if (input.type === 'number' && Number.isNaN(Number(value))) {
        return { invalid: true, message: requiredMessage };
      }
      return { invalid: false };
    }

    function validateFields() {
      form.querySelectorAll('.hdt-wf__field--invalid').forEach(clearFieldError);
      let valid = true;
      let firstInvalid = null;

      Array.from(form.querySelectorAll('input, select, textarea'))
        .filter(isRequiredInput)
        .forEach((input) => {
          const result = isFieldInvalid(input);
          if (result.invalid) {
            valid = false;
            markInvalid(input, result.message);
            if (!firstInvalid) firstInvalid = input;
          }
        });

      if (firstInvalid) {
        try {
          firstInvalid.focus({ preventScroll: false });
        } catch (e) {
          firstInvalid.focus();
        }
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return valid;
    }

    form.addEventListener('input', (event) => {
      const field = event.target.closest('.hdt-wf__field');
      if (!field || !field.classList.contains('hdt-wf__field--invalid')) return;
      if (!isFieldInvalid(event.target).invalid) clearFieldError(field);
    });

    form.addEventListener('change', (event) => {
      const field = event.target.closest('.hdt-wf__field');
      if (!field || !field.classList.contains('hdt-wf__field--invalid')) return;
      if (!isFieldInvalid(event.target).invalid) clearFieldError(field);
    });

    form.addEventListener('submit', (event) => {
      if (!validateFields()) {
        event.preventDefault();
      }
      // Valid → do not preventDefault. Native Shopify submit + platform captcha.
    });
  }

  function boot() {
    document.querySelectorAll('[data-hdt-wf]').forEach(initWholesaleForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-hdt-wf]');
    if (root) initWholesaleForm(root);
  });
})();
